<i18n>
{
  "fr": {
    "title": "Détail du formulaire VE",
    "ve": "Visite d'Entretien - N°{number}",
    "plotSurface": "Surface Parcelle (m²) :",
    "activeSurface": "Surface Active (m²) :",
    "leakFlowRate": "Débit de fuite prescrit (L/s) :",
    "leakFlowNotice": "Débit de fuite constaté (L/s) :",
    "rateVolume": "Volume prescrit (m³) :",
    "volumeNotice": "Volume constaté (m³) :",
    "deconnexionEuxPluvConst":"Déconnexion des eaux pluviales constatée jusqu'à la pluie décennale :",
    "disconnectionWaterPrescrite":"Déconnexion des eaux pluviales prescrite jusqu'à la pluie décennale :",
    "surfaceDisconnectConst":"Surface déconnectée constatée (m²) :",
    "surfaceDisconnectPrescrite":"Surface déconnectée prescrite (m²) :",
    "totalDisconnectionOfRainwater": "Déconnexion totale constatée des eaux pluviales",
    "partialDisconnectionOfRainwater": "Déconnexion partielle constatée des eaux pluviales",
    "disconnectedSurface": "Surface déconnectée (m²) :",
    "dateOfNextVisit": "Date prochaine visite :",
    "visitInfo": "Informations sur la visite",
    "dateOfVisit": "Date de la visite :",
    "timeToVisit": "Heure de la visite :",
    "teamControl": "Equipe ayant effectuée le contrôle :",
    "contact": "Contact :",
    "maintenanceBookPresented": "Carnet d'entretien présenté :",
    "technicalReceptionTime": "Réception technique avant ou après visite :",
    "folderInfo": "Informations sur le dossier",
    "result": "Résultat conforme",
    "resultComment":"Commentaire :",
    "infoRemmeber": "Rappel de la décomposition des surfaces",
    "resume": "Conclusion",
    "cancel": "Retour",
    "signature": "Signature",
    "technical_drawings": "Dessin Technique",
    "technical": "Technique",
    "synoptic": "Synoptique",
    "download": "Télécharger",
    "deleteControl": "Supprimer le contrôle",
    "editControl": "Éditer le contrôle",
    "delete_control_confirmation_message": "Attention ! Vous vous apprêtez à supprimer le contrôle. La suppression est définitive. Le contrôle sera effacée de la base. Apres validation de la suppression, il ne sera plus possible de revenir en arrière. Vous confirmez ?"
    }
}
</i18n>
<template>
  <div>
    <InfoBar :title="this.$i18n.t('title')">
      <template v-slot:cancelbtn>
        <b-link class="btn s-btn-b btn-gray mg-r-15 pull-right" @click="onCancel">{{ $t('cancel') }}</b-link>
      </template>
    </InfoBar>
    <hr />
    <WorkflowTimeline />

    <FileDetail
      :photos="veForm.photos"
      :schemas="veForm.schemas"
      :technicalFiles="veForm.technicalFiles"
      :reports="veForm.reports"
      :others="veForm.others"
    />
    <div class="panel panel-info text-left">
      <div class="panel-heading">{{ $t('ve', { number: property.folderNumber }) }}</div>
      <div class="panel-body">
        <Content title v-if="property.conception">
          <span slot="main-text-1">
            <h4>{{ $t('folderInfo') }}</h4>
            <hr />
            <h5>{{ $t('infoRemmeber') }}</h5>
            <p class="text">
              {{ $t('plotSurface') }}
              <span v-if="![null, ''].includes(this.getFrozenControlPropertyAttribute('plotSurface'))">{{
                `${new Intl.NumberFormat().format(this.getFrozenControlPropertyAttribute('plotSurface'))}`
              }}</span>
            </p>
            <p class="text">
              {{ $t('activeSurface') }}
              <span v-if="![null, ''].includes(this.getFrozenControlPropertyAttribute('activeSurface'))">{{
                `${new Intl.NumberFormat().format(this.getFrozenControlPropertyAttribute('activeSurface'))}`
              }}</span>
            </p>
            <hr />
            <p class="text">
              {{ $t('leakFlowRate') }}
              <span v-if="![null, ''].includes(this.getFrozenControlPropertyAttribute('leakFlowRate'))">{{
                `${new Intl.NumberFormat().format(this.getFrozenControlPropertyAttribute('leakFlowRate'))}`
              }}</span>
            </p>
            <p class="text">
              {{ $t('leakFlowNotice') }}
              <span v-if="![null, ''].includes(veForm.leakFlowNotice)">{{
                `${new Intl.NumberFormat().format(veForm.leakFlowNotice)}`
              }}</span>
            </p>
            <p class="text">
              {{ $t('rateVolume') }}
              <span v-if="![null, ''].includes(this.getFrozenControlPropertyAttribute('rateVolume'))">{{
                `${new Intl.NumberFormat().format(this.getFrozenControlPropertyAttribute('rateVolume'))}`
              }}</span>
            </p>
            <p class="text">
              {{ $t('volumeNotice') }}
              <span v-if="![null, ''].includes(veForm.volumeNotice)">{{
                `${new Intl.NumberFormat().format(veForm.volumeNotice)}`
              }}</span>
            </p>
            <p class="text">
              {{ $t('disconnectionWaterPrescrite') }}
              <span>{{ getValuePrescrite(this.getFrozenControlPropertyAttribute('disconnectionOfRainwater')) }}</span>
            </p>
            <p class="text">
              {{ $t('deconnexionEuxPluvConst') }}
              <span>{{ getValuePluviaal(veForm.disconnectionOfRainwater) }}</span>
            </p>
            <p class="text">
              {{ $t('surfaceDisconnectPrescrite') }}
              <span>{{ new Intl.NumberFormat().format(this.getFrozenControlPropertyAttribute('surfaceDisconnect')) }}</span>
            </p>
            <p class="text">
              {{ $t('surfaceDisconnectConst') }}
              <span>{{ new Intl.NumberFormat().format(veForm.surfaceDisconnect) }}</span>
            </p>
          </span>
          <span slot="main-text-2">
            <h4>{{ $t('visitInfo') }}</h4>
            <hr />
            <p class="text">
              {{ $t('dateOfVisit') }}
              <span>{{ veForm.dateOfVisit | moment('DD/MM/YYYY') }}</span>
            </p>
            <p class="text">
              {{ $t('timeToVisit') }}
              <span>{{ veForm.timeToVisit }}</span>
            </p>
            <p class="text">
              {{ $t('teamControl') }}
              <span>{{ veForm.teamControl }}</span>
            </p>
            <p class="text">
              {{ $t('contact') }}
              <span>{{ this.getContact(veForm.contact) }}</span>
            </p>
            <p class="text">
              {{ $t('maintenanceBookPresented') }}
              <span>{{ getValueOf(veForm.maintenanceBookPresented) }}</span>
            </p>
            <p class="text">
              {{ $t('dateOfNextVisit') }}
              <span>{{ veForm.dateOfNextVisit | moment('DD/MM/YYYY') }}</span>
            </p>
          </span>
        </Content>
      </div>
    </div>
    <WorksDetail v-if="property.conception" :form="veForm" typeForm="ve" />
    <div class="panel panel-info text-left">
      <div class="panel-heading">{{ $t('resume') }}</div>
      <div class="panel-body">
        <p class="text">
              {{ $t('resultComment') }}
              <span>{{ veForm.resultComment }}</span>
        </p>
        <p class="text">
          <template v-if="veForm.result == 1">
            <v-icon name="check" />
          </template>
          <template v-else>
            <v-icon name="times" class="nok" />
          </template>
          {{ $t('result') }}
        </p>
      </div>
    </div>

    <div class="panel panel-info text-left">
      <div class="panel-heading">{{ $t('technical_drawings') }}</div>
      <div class="panel-body">
        <div class="row">
          <div v-if="veForm.technicalDrawingImage" class="col-sm-6">
            <h4 class="header-title">{{ $t('technical') }}</h4>
            <div class="text-center">
              <img v-bind:src="getFileUrl(controlId, veForm.technicalDrawingImage)" class="img-drawing" />
              <br />
              <a v-bind:href="this.getFileUrl(this.controlId, veForm.technicalDrawingImage)" target="_blank">{{
                $t('download')
              }}</a>
            </div>
          </div>
          <div v-if="veForm.synopticDrawingImage" class="col-sm-6">
            <h4 class="header-title">{{ $t('synoptic') }}</h4>
            <div class="text-center">
              <img v-bind:src="getFileUrl(controlId, veForm.synopticDrawingImage)" class="img-drawing" />
              <br />
              <a v-bind:href="this.getFileUrl(this.controlId, veForm.synopticDrawingImage)" target="_blank">{{
                $t('download')
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-info text-left">
      <div class="panel-heading">{{ $t('signature') }}</div>
      <div class="panel-body">
        <div v-if="this.veForm.signature !== null && this.veForm.signature !== 'undefined'">
          <b>Signataire :</b>
          {{ this.veForm.signator }}
          <br />
          <img v-bind:src="'/fr/file/' + this.controlId + '/preview/' + this.veForm.signature" class="signature" />
          <br />
          {{ this.veForm.signatureDateTime }}
        </div>
      </div>
    </div>

    <Workflow :controlForm="veForm" />

    <SendControlAttachmentsToGed
      v-bind:dateOfVisit="veForm.dateOfVisit"
      v-bind:control-id="controlId"
      v-bind:contract-id="contractId"
      v-bind:property-id="property.id"
    />

    <WorkflowHistory />

    <button v-show="canDeleteControl()" class="btn btn-danger s-btn-danger pull-right" v-on:click="deleteControl()">
      {{ $t('deleteControl') }}
    </button>

    <div class="pull-right">&nbsp;</div>

    <button v-show="canEditControl()" class="btn btn-danger s-btn-danger pull-right" v-on:click="editControl()">
      {{ $t('editControl') }}
    </button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Workflow from '../Workflow';
import WorkflowHistory from '../WorkflowHistory';
import WorkflowTimeline from '../WorkflowTimeline';
import InfoBar from '../properties/InfoBar';
import Content from '../Content';
import FileDetail from './FileDetail';
import WorksDetail from './WorksDetail';
import VueJwtDecode from 'vue-jwt-decode';
import SendControlAttachmentsToGed from './SendControlAttachmentsToGed';
import { getEndpoint } from '../../store/endpoints';
import axios from 'axios';

export default {
  Name: 'VeDetail',
  components: {
    Workflow,
    InfoBar,
    Content,
    FileDetail,
    WorksDetail,
    WorkflowHistory,
    WorkflowTimeline,
    SendControlAttachmentsToGed,
  },
  data() {
    return {
      contractId: null,
      eServices: null,
    };
  },
  created() {
    this.getRequestVeById();
    this.initNotif();
  },
  mounted() {
    this.jwtDecoded = VueJwtDecode.decode(this.$store.state.app.parameters.jwt);
    this.contractId = this.jwtDecoded.data.user.contractsIds[0];
    this.eServices = this.jwtDecoded.data.user.eServices;
  },
  computed: {
    ...mapState({
      property: (state) => state.refProperties.property,
      veForm: (state) => state.ve.veForm,
      controlId: (state) => state.route.params.controlId,
      workflows: (state) => state.workflow.workflows,
    }),
  },
  methods: {
    ...mapActions(['getRequestVeById', 'initNotif']),
    getValue(value) {
      return value == 'oui' ? true : false;
    },
    getContact(value) {
      const contact = this.property.contacts.find((contact) => contact.id === value);
      return contact != null ? `${contact.firstName} ${contact.name}` : '';
    },
    getValueOf(value) {
      const options = {
        before: 'Avant',
        after: 'Après',
        'non-presented': 'Non présenté',
        presented: 'Présenté',
        'send-back': 'A renvoyer',
      };
      return options[value];
    },
    onCancel() {
      this.$router.push({ name: `property_detail`, params: { propertyId: this.property.id } });
    },
    getValuePrescrite(value) {
      let arr = [
        { text: 'Aucune', value: 'none' },
        {
          text: "Déconnexion totale",
          value: 'totalDisconnection',
        },
        {
          text: "Déconnexion partielle",
          value: 'partialDisconnection',
        },
      ];
      let obj = arr.find((p) => p.value === value);
      if (obj) {
        return obj.text;
      } else {
        return '';
      }
    },
    getValuePluviaal(value) {
      let arr = [
        { text: 'Aucune', value: 'none' },
        {
          text: "Déconnexion totale",
          value: 'totalDisconnection',
        },
        {
          text: "Déconnexion partielle",
          value: 'partialDisconnection',
        },
      ];
      let obj = arr.find((p) => p.value === value);
      if (obj) {
        return obj.text;
      } else {
        return '';
      }
    },
    getFileUrl: function (requestId, fileId) {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      return getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl;
    },
    hasValidatedStatus() {
      if (this.workflows) {
        for (let index = 0; index < this.workflows.length; index++) {
          const workflow = this.workflows[index];
          if (workflow.status.id == 'validated') {
            return true;
          }
        }
      }

      return false;
    },
    getFrozenControlPropertyAttribute(attribute) {
      if (this.hasValidatedStatus()) {
        if (
          ['surfaceDisconnect', 'plotSurface', 'activeSurface', 'leakFlowRate', 'rateVolume', 'disconnectionOfRainwater'].includes(attribute)
        ) {
          attribute = `conception${attribute.charAt(0).toUpperCase() + attribute.slice(1)}`;
        }
        return this.veForm[attribute];
      }

      return this.property.conception[attribute];
    },
    deleteControl() {
      if (!confirm(this.$t('delete_control_confirmation_message'))) {
        return false;
      }

      let endpoint = getEndpoint('ve', null, this.$route.params.controlId, null).delete;
      let _this = this;

      axios.delete(endpoint).then(function () {
        _this.$router.push({
          name: `controls`,
        });
      });
    },
    canDeleteControl() {
      if (this.contractId) {
        if (this.eServices[this.contractId]['CONTROLES']['DELETE'] === true) {
          return true;
        }
      }

      return false;
    },
    editControl() {
      this.$router.push({
        name: `ve_edit`,
        params: { controlId: this.$route.params.controlId, propertyId: this.$route.params.propertyId },
      });
    },
    canEditControl() {
      if (this.contractId) {
        if (this.eServices[this.contractId]['CONTROLES']['EDIT'] === true) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style scoped>
.img-drawing {
  height: 200px;
}
</style>
